/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import { MenuData } from '../models';
import { getExtra } from '../menu-helpers';

interface MegaMenuExtraProps {
    data: MenuData;
    activePath: number[];
}

export default class MegaMenuExtra extends React.Component<MegaMenuExtraProps> {
    render(): JSX.Element | null {
        const { data, activePath } = this.props;
        const extra = getExtra(data, activePath);
        if (!extra) return null;

        const text =
            extra.text &&
            extra.text
                .split(/®/)
                .reduce((acc, el) => {
                    acc.push(el);
                    acc.push(<sup>®</sup>);
                    return acc;
                }, [] as (JSX.Element | string)[])
                .slice(0, -1);

        return (
            <div className="mega-menu__modal-extra">
                {text && (
                    <div className="mega-menu__modal-extra__content">
                        <h2 className="h4">{extra.heading}</h2>
                        {text && <p className="body-copy">{text}</p>}
                    </div>
                )}
                <div className="mega-menu__modal-extra__image">
                    <img className="image image--cover" src={extra.img.src} alt={extra.img.alt} loading="lazy" />
                </div>
            </div>
        );
    }
}
